import { Component } from '@angular/core';
import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';

@Component({
  selector: 'accessibility-text',
  template: `
  <div class="modal" tabindex="-1" id="dialog-accessibility">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">ACCESSIBILITY ASSISTANCE</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div [innerHTML]="agilityContentModelAccessability"></div>              
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
  </div>
  `,
  styleUrl: './accessibility.component.scss',
  standalone: true,
  host: {'class': 'accessibility-text'},
})
export class AccessibilityComponent {

  constructor(
    private readonly directSessionLogic: DirectSessionLogicService
  ) {

  }

  get agilityContentModelAccessability(): string {
    return this.directSessionLogic.agilityObjectsSignalValue.accessibilityBody;
  }

}
